import { render, staticRenderFns } from "./DetailsSearchSelector.vue?vue&type=template&id=3c1a4998&scoped=true"
import script from "./DetailsSearchSelector.vue?vue&type=script&lang=ts"
export * from "./DetailsSearchSelector.vue?vue&type=script&lang=ts"
import style0 from "./DetailsSearchSelector.vue?vue&type=style&index=0&id=3c1a4998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a4998",
  null
  
)

export default component.exports